import { useQuery } from '@tanstack/react-query';
import { fetchSelectionLists } from './fetchSelectionLists';
import { browserClient } from '../../react-query';
import { globalErrorResponse } from '../../shared/notification/actions';
import { AxiosError } from 'axios';
import { GlobalReactQueryOptions } from '../../config';
import { useListActionTarget } from '../../app-store/addToCartOrList/useListActionTarget';

const SELECTION_LISTS_QUERY = 'selectionLists';

export const useSelectionLists = () => {
    const { data, ...rest } = useQuery([SELECTION_LISTS_QUERY], fetchSelectionLists, {
        ...GlobalReactQueryOptions,
        staleTime: 5 * 60 * 1000,
        onError: (error: AxiosError) => {
            globalErrorResponse(error);
        }
    });

    const selectionLists = data || [];
    const activeList = selectionLists.length > 0 ? selectionLists[0] : undefined;
    const { targetSelectionListId } = useListActionTarget();
    const selectedListId = targetSelectionListId ?? activeList?.id;

    const selectedSelectionList = selectionLists.find(item => item.id === selectedListId);

    return {
        ...rest,
        selectionLists,
        activeList,
        selectedSelectionList
    };
};

export const invalidateSelectionLists = () => {
    return browserClient.invalidateQueries({ queryKey: [SELECTION_LISTS_QUERY] });
};
